(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name manageUser.controller:ManageUserCtrl
   *
   * @description
   *
   */
  angular
    .module('manageUser')
    .directive('focusOn',function($timeout) {
      return {
        restrict : 'A',
        link : function(vm,$element,$attr) {
          vm.$watch($attr.focusOn,function(_focusVal) {
            $timeout(function() {
              _focusVal ? $element[0].focus() : $element[0].blur();
            });
          });
        }
      }
    })
    .controller('ManageUserCtrl', ManageUserCtrl);

  function ManageUserCtrl(EventManagerService,ManageUserServices,MessageService,PopupManager,applicationConstants) {
    var vm = this;
    vm.ctrlName = 'ManageUserCtrl';

    vm.model = {
      searchOnGoing : false,
      searchPanelToggle:true,
      editorMode:applicationConstants.EDITOR_STATUS.ADD,
      searchCriteria:{
        loginId:null,
        displayName : null,
        userType : null,
        status : null,
        roles :null
      },
      masterList:{
        userTypes:[],
        statusList:[],
        crewTypes:[],
        roles:[],
        crewList:[],
        msgRecipients:[],
        airports:[],
        crewTypeReadOnly : false,
        crewNameReadOnly : false,
        displayNameReadOnly : false
      },
      basicCrewTypes :[],
      userList:[],
      selectedUser:null,
      isElasticLoadingVisible:false,
      fullUserList:[],
      isActive:true,
      isInactive:true,
      activeDisabled:true,
      inactiveDisabled:true

    };

    EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
    };

    vm.searchByOptions = function(searchParams){
      setDefault();
      if(searchParams.status!=null && searchParams.status.value=="ACT"){
        vm.model.isActive=true;
        vm.model.isInactive=false;
        vm.model.activeDisabled=true;
        vm.model.inactiveDisabled=true;

      }else if(searchParams.status!=null && searchParams.status.value=="INA"){
        vm.model.isActive=false;
        vm.model.isInactive=true;
        vm.model.activeDisabled=true;
        vm.model.inactiveDisabled=true;

      }else{
        vm.model.isActive=true;
        vm.model.isInactive=true;
        vm.model.activeDisabled=false;
        vm.model.inactiveDisabled=false;

      }
      vm.searchUsers();
    }

    vm.searchUsers = function() {
      vm.model.userList = [];
      vm.model.fullUserList =[];
      vm.model.searchCriteria.startPosition = 1;
      searchUser();
    };

    vm.selectUser = function (selectedRowData) {
      vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
      var user =  ManageUserServices.userGridRowToUserDTO(selectedRowData);
      var crewName = user.crewName;
      vm.model.selectedUser = user;
      setCrewTypes();
      setCrewName();
      vm.model.selectedUser.crewName = crewName;
    };

    vm.addNewUser = function() {
      vm.model.editorMode =  applicationConstants.EDITOR_STATUS.ADD;
      vm.model.selectedUser = ManageUserServices.getNewUser();
      vm.model.masterList.crewTypeReadOnly = false;
      vm.model.masterList.crewNameReadOnly = false;
      vm.model.masterList.displayNameReadOnly = false;
    };

    vm.submitUser = function(action, selectedItem) {
      if (action === applicationConstants.EDITOR_STATUS.DELETE){
        deleteUser(selectedItem);
      }else{
        saveUser();
      }
    }

    vm.changeEditorField = function(flag){
      switch (flag) {
        case "USER_TYPE":
          vm.model.selectedUser.crewTypeCode = null;
          setCrewTypes();
          break;
        case "CREW_TYPE":
          setCrewName();
          break;
        case "CREW_NAME":
          crewNameSelect();
          break;
        case "PASSWORD":
          setPasswordChanged();
          break;
        case "PASSWORD_CONF":
          setPasswordChanged();
          break;
        default:
          break;
      }
    };

    function setPasswordChanged(){
      vm.model.selectedUser.passwordChanged = true;
    }

    function crewNameSelect(){
      var crewName = vm.model.selectedUser.crewName;
      vm.model.selectedUser.displayName = crewName.fullName;
    }

    function setCrewTypes(){
      var selectedData = vm.model.selectedUser;
      vm.model.masterList.crewTypes = [];
      vm.model.masterList.crewList = [];
      vm.model.selectedUser.crewType = null;
      vm.model.selectedUser.crewName = null;


      vm.model.masterList.crewTypeReadOnly = false;
      vm.model.masterList.crewNameReadOnly = false;
      vm.model.masterList.displayNameReadOnly = false;
      vm.model.masterList.crewTypeRequired = false;

      if(selectedData.userType != null && selectedData.userType.userTypeCode == "Crew") {
        vm.model.masterList.crewTypes = vm.model.basicCrewTypes;
        vm.model.masterList.crewTypeReadOnly = true;
        vm.model.masterList.crewNameReadOnly = true;
        vm.model.masterList.displayNameReadOnly = true;
        vm.model.masterList.crewTypeRequired = true;
      }
    }

    function setCrewName(){
      var data = vm.model.selectedUser.crewTypeCode;

      if(data == null || data.crewTypeCode == null){
        return;
      }

      vm.model.masterList.crewList = null;
      vm.model.selectedUser.crewName = null;
      ManageUserServices.searchCrewNamesByCrewType(data,
        function(crewList){
          vm.model.masterList.crewList = crewList;
        },
        function(error){
          MessageService.error(error);
        }
      );
    }

    function searchUser() {
      showLoader(true);
      ManageUserServices.setSearchCriteria(vm.model.searchCriteria);
      ManageUserServices.searchUsers(
        function (userList,startPosition) {
          updateUserList(userList);
          updateGridSearchStartPosition(startPosition);
          vm.model.searchPanelToggle = false;
          showLoader(false);
          vm.model.searchOnGoing = false;
        },
        function (error) {
          MessageService.error(error);
          showLoader(false);
        }
      );
    }

    function getNextSetOfRecords() {
      vm.model.isElasticLoadingVisible = true;
      if(!vm.model.searchOnGoing){
        vm.model.searchOnGoing = true;
        searchUser();
      }
    }

    function setDefault() {
      vm.model.searchCriteria.pageSize = 25;
      vm.model.searchCriteria.startPosition = 1;
      vm.model.masterList.statusList = ManageUserServices.searchStatusOptions();
      vm.model.masterList. crewTypeRequired = false;
      vm.model.masterList.crewNameRequired = false,
        vm.model.masterList.displayNameReadOnly = false
      vm.addNewUser();
    }

    function updateUserList(users) {
      angular.forEach(users, function (crew) {
        var formaterCrew = ManageUserServices.formatUserType(vm.model.masterList.userTypes,crew);
        vm.model.userList.push(formaterCrew);
        vm.model.fullUserList.push(formaterCrew);
      });
      vm.model.isElasticLoadingVisible = false;
    }

    function showLoader(flag) {
      EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
        flag: flag,
        target: 'manageUser',
        animationName: 'crewing-loader'
      });
    }

    function updateGridSearchStartPosition(startPosition) {
      vm.model.searchCriteria.startPosition = startPosition;
    }

    function saveUser() {
      ManageUserServices.saveUser(vm.model.selectedUser, vm.model.masterList,
        function (response) {
          if(response.success){
            MessageService.success('Successfully saved the record!');
            if(response.warnings.length>0){
              angular.forEach(response.warnings,function(warning){
                MessageService.warning(warning);
              });
            }
            vm.searchUsers();
            vm.addNewUser();
          }else{
            MessageService.error(response.errors[0]);
          }
        },
        function (error) {
          MessageService.error(error);
        }
      );
    }

    function deleteUser(selectedItem){
      var param = {
        title: 'Confirmation',
        messages: ["Do you want to delete this record"],
        flags: selectedItem
      };
      PopupManager.openModal('CONFIRM_DIALOG', param, confirmDeleteDialog);
    }


    function confirmDeleteDialog(pass) {
      if(pass==='YES'){
        ManageUserServices.deleteUser(vm.model.selectedUser,
          function (response) {
            MessageService.success('Successfully deleted the record!');
            vm.searchUsers();
            vm.addNewUser();
          },
          function (error) {
            MessageService.error(error);
          }
        );
      }
    }

    vm.filterUserlist= function() {
      if(vm.model.isActive==true && vm.model.isInactive==false){
        vm.model.userList=vm.model.fullUserList.filter(function (user) {
          console.log(user.status.statusCode)
          return user.status.statusCode=="ACT"
        });
        console.log("Active")
      }else if(vm.model.isInactive==true && vm.model.isActive==false){
        vm.model.userList=vm.model.fullUserList.filter(function (user) {
          console.log(user.status.statusCode)
          return user.status.statusCode=="INA"
        });
        console.log("Inactive")
      }
      else if(vm.model.isInactive==true && vm.model.isActive==true){
        vm.model.userList=vm.model.fullUserList;
        console.log("INActive and active")

      }else {
        vm.model.userList=[];
      }
    }

    ManageUserServices.searchUserTypes(
      function (userTypes) {
        vm.model.masterList.userTypes = userTypes;
        setDefault();
      },
      function(error) {
        MessageService.error(error);
      }
    );

    ManageUserServices.searchCrewTypes(
      function(crewTypes){
        vm.model.basicCrewTypes = crewTypes;
        vm.model.masterList.msgRecipients = vm.model.basicCrewTypes;
      },
      function(error){
        MessageService.error(error);
      }
    );

    ManageUserServices.searchRoles(
      function(roles){
        vm.model.masterList.roles = roles;
      },
      function(error){
        MessageService.error(error);
      }
    );

    ManageUserServices.loadAirportList(
      function(airports){
        vm.model.masterList.airports = airports;
      },
      function(error){
        MessageService.error(error);
      }
    );

  }
}());
